import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface IntegrityRow { id?: string; [k: string]: any; }
export interface IntegrityGroup { count: number; severity?: "bad" | "warning"; rows: IntegrityRow[]; }
export interface StreamFinanceSummary {
  key: "main" | "side"; label: string; finance_rows: number;
  income: number; expense: number; ledger_balance: number;
  receivable_tasks: number; receivable_total: number;
  statement_matched_balance: number; reconcile_diff: number;
}
export interface IntegrityReport {
  total: number; bad_rows: number; bad_total: number; warning_total: number; clean: boolean;
  streams: Record<"main" | "side", StreamFinanceSummary>;
  unassigned_statement?: { statement_rows: number; balance: number };
  groups: Record<string, IntegrityGroup>;
  audit_recent: Array<{ id:string; entity_type:string; entity_id:string; action:string; summary:string|null; user_id:string|null; undone_at:string|null; created_at:string }>;
}
export function useFinanceIntegrity() {
  return useQuery({
    queryKey: ["finance_integrity"],
    queryFn: () => api.get<IntegrityReport>("/finance-integrity"),
    staleTime: 15_000,
  });
}
